import React, { useState, useEffect, useRef } from 'react';

const LazyLoad = ({ children, threshold = 0.1, rootMargin = '50px', fallback = null }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const containerRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasLoaded) {
          // Remove the delay to prevent flickering
          setIsVisible(true);
          setHasLoaded(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold,
        rootMargin
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
      observer.disconnect();
    };
  }, [threshold, rootMargin, hasLoaded]);

  // Prevent re-renders by using a stable fallback
  const stableFallback = fallback || (
    <div className="h-96 flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-purple-400 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );

  return (
    <div ref={containerRef} data-lazy-container>
      {isVisible ? children : stableFallback}
    </div>
  );
};

export default LazyLoad;